import { Details } from '@/client/Common/Components/Details';
import { DetailsProvider } from '@/client/Common/provider/DetailsProvider';
import { createFileRoute, redirect, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/details/$train/h/$jid')({
	loader: async (ctx) => {
		try {
			const details = await ctx.context.trpcUtils.journeys.detailsByJid.fetch(
				ctx.params.jid,
			);
			if (details?.journeyId) {
				return redirect({
					to: '/details/$train/j/$journeyId',
					replace: true,
					params: {
						train: details.train.name,
						journeyId: details.journeyId,
					},
				});
			}
		} catch {
			// ignore
		}
	},
	component: () => {
		const { jid, train } = useParams({
			from: '/details/$train/h/$jid',
		});

		return (
			<DetailsProvider trainName={train} jid={jid}>
				<Details />
			</DetailsProvider>
		);
	},
});
